import { useQuery } from "@tanstack/react-query";
import { SeatDetails } from "features/types";
import { get } from "services/http";

export interface SectionRowDetails {
  section: string;
  sectionDisplay: string;
  row: string;
  rowDisplay: string;
  ga: boolean;
}

interface FindSeatsBySectionAndRowRequest {
  venueId: number;
  section?: string;
  row?: string;
  eventTypeName: string;
}

interface FindRowsBySectionsRequest {
  venueId?: number;
  sectionNames: string[];
  eventTypeName: string;
}

export const findSeatsBySectionAndRowRequest = (
  params: FindSeatsBySectionAndRowRequest
) => {
  const { venueId, ...otherParams } = params;
  return get<SeatDetails[]>({
    url: `/venues/${venueId}/tenant/seats`,
    params: otherParams,
  });
};

export const useFindRowsBySectionsQuery = (
  params: FindRowsBySectionsRequest
) => {
  return useQuery(
    ["fetchRowsBySections", params.venueId, params.sectionNames],
    () => {
      const { venueId, ...otherParams } = params;
      return get<Array<SectionRowDetails>>({
        url: `/venues/${venueId}/tenant/rows`,
        params: otherParams,
      });
    },
    {
      staleTime: Infinity,
      enabled: !!params.venueId && params.sectionNames.length > 0,
    }
  );
};
